import React, { useState } from 'react';
import { http } from '../../fx-core';

interface CommunityItem {
  communityId: number;
  communityName: string;
}

interface OverrideItem {
  communityId: number;
  isActive: boolean;
}

interface Props {
  stallItemId: number | string;
  specialCommunities: CommunityItem[];
  overrides: OverrideItem[];
}

const CommunityCapsules: React.FC<Props> = ({ stallItemId, specialCommunities, overrides }) => {
  // Build local active state from props
  const buildActiveMap = () => {
    const map: Record<number, boolean> = {};
    (specialCommunities || []).forEach(c => {
      map[c.communityId] = true; // default active
    });
    (overrides || []).forEach(o => {
      map[o.communityId] = o.isActive;
    });
    return map;
  };

  const [activeMap, setActiveMap] = useState<Record<number, boolean>>(buildActiveMap);
  const [toggling, setToggling]   = useState<number | null>(null);

  if (!specialCommunities || specialCommunities.length === 0) {
    return <span style={{ color: '#aaa', fontSize: 11 }}>—</span>;
  }

  const handleToggle = (communityId: number) => {
    setToggling(communityId);
    http.post({
      url: 'stallitem/community/toggle',
      data: { stallItemId, communityId }
    })
      .then((res: any) => {
        const newActive = res.data?.isActive ?? res.data?.IsActive;
        setActiveMap(prev => ({ ...prev, [communityId]: newActive }));
      })
      .finally(() => setToggling(null));
  };

  return (
    <div style={{ display: 'flex', flexWrap: 'wrap', gap: 5 }}>
      {specialCommunities.map(c => {
        const isActive = activeMap[c.communityId] ?? true;
        const isBusy   = toggling === c.communityId;

        return (
          <button
            key={c.communityId}
            onClick={() => !isBusy && handleToggle(c.communityId)}
            disabled={isBusy}
            title={isActive
              ? `Click to hide from ${c.communityName}`
              : `Click to show in ${c.communityName}`}
            style={{
              padding: '2px 10px',
              borderRadius: 20,
              fontSize: 11,
              fontWeight: 600,
              cursor: isBusy ? 'not-allowed' : 'pointer',
              transition: 'all 0.2s',
              background:  isActive ? '#F97316' : 'transparent',
              color:       isActive ? '#fff'    : '#9CA3AF',
              border:      isActive ? '2px solid #F97316' : '2px solid #D1D5DB',
              opacity:     isBusy  ? 0.5 : 1,
              whiteSpace:  'nowrap',
            }}
          >
            {isBusy ? '...' : c.communityName}
          </button>
        );
      })}
    </div>
  );
};

export default CommunityCapsules;